module.exports = __webpack_public_path__ + "static/media/ke.16b504a4.png";